import { ButtonVariant, CoButton } from "components/CoButton";
import { ManageUploadedPaperDropdown } from "features/ResearchHub";
import useLabels from "hooks/useLabels";
import { PaperAccessButtonProps } from "./types";

/**
 * ManagePdfButton is a button that opens the manage PDF dropdown so user can delete or download the uploaded PDF
 */
const ManagePdfButton: React.FC<PaperAccessButtonProps> = ({
  uploaded_paper_id,
  isUploading,
  onDelete,
}) => {
  const [labels] = useLabels("paper-access-button");
  if (!uploaded_paper_id) return null;

  return (
    <ManageUploadedPaperDropdown
      uploaded_paper_id={uploaded_paper_id}
      isUploading={isUploading ?? false}
      onDelete={() => {
        onDelete?.();
      }}
    >
      <CoButton
        variant={ButtonVariant.Secondary}
        label={labels["manage-pdf"]}
        size="sm"
        iconRight="icon-chevron-down"
      />
    </ManageUploadedPaperDropdown>
  );
};

export default ManagePdfButton;
